import { render, staticRenderFns } from "./Table31El.vue?vue&type=template&id=cdb8a30c&scoped=true&"
import script from "./Table31El.vue?vue&type=script&lang=ts&"
export * from "./Table31El.vue?vue&type=script&lang=ts&"
import style0 from "./Table31El.vue?vue&type=style&index=0&id=cdb8a30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb8a30c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
